import React from "react"
import styled from "@emotion/styled"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { Headphones } from "phosphor-react";

import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

import Recent from "./recent"

const Divwrap = styled.div`
h2 {
    margin-bottom: 2.5vh;
    font-family: 'OpticianSans';
    font-size: 1.33rem;
    letter-spacing: 1px;    
}
@media (max-width: 599px) {
    transform: none;
    grid-row: 1;
}
`
const Onair = styled.div`
    ul {
        margin-bottom: 2.5vh;
        height: 50vh;
        overflow-y: scroll;
        background-color: white;
    }
    li {
        list-style: none;
        font-family: "FaktPro-Normal";
        padding-top: 1vh;
        padding-bottom: .5vh;
        font-size: .9125em;
        border-bottom: solid 1px rgba(0,0,0,0.2);
        @media (max-width: 599px) {
            font-size: 1rem;
        }  

    }
`
const Subhead = styled.h2`
    color: #000;
    background: #fff;
    margin-bottom: 2.5vh;
    font-family: 'OpticianSans';
    font-size: 1.33rem;
    letter-spacing: 1px;
`

export default function CenterMiddle() {
    return (
        <Divwrap>
            {/* <SimpleBar autoHide={false}> */}
            <Onair>
                <Subhead>Recently Played</Subhead>
                <Recent />
            </Onair>
            {/* </SimpleBar> */}
       </Divwrap>
    )
}